var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroGradientShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 427.5 746.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M42.24 518L64.5 512L61 540L51.5 593.5L42.24 622.814L42.24 632L44.5 643L43.37 666.933L44.5 696L39 746.5H382.263L375.476 676.668L382.263 628.244L370 592L361.5 555L355.585 519.163L376.5 524L385.5 525.5L398 519.163L418.319 496.225L427.5 446.272L391.797 315.782L376.649 273.141L361.5 230.5L306.5 185L300 160L294.5 126L283 81L263.5 40.5L237.5 13L213 0H183.5L138.5 31.5L129 57.5L117.908 112.586V167.31L98.9105 220.958L65 230.5L42.24 265.5L25 332L10.2898 405L1.61914 426.5L0 453.5L1.61914 466.5L22.5 506.5L42.24 518Z",
    fill: "url(#paint0_linear_0_94)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_94",
    x1: 145.96,
    y1: 385.615,
    x2: 380.884,
    y2: 747.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687709,
    stopColor: "#C7E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7E5F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroGradientShape);
export default __webpack_public_path__ + "static/media/hero-gradient-shape.0e777172b843776e0bf76f4a310f5d3f.svg";
export { ForwardRef as ReactComponent };